import * as v from "valibot";
import { rpcContract } from "../rpc";

export const resendPurchaseVerificationEmailRpcContract = rpcContract({
  name: "resend-purchase-verification-email" as const,
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.minLength(1, "Email is required"), v.email("Invalid email format")),
    eventHandle: v.string(),
    eventId: v.string(),
  }),
  resultSchema: v.object({}),
});

export type ResendPurchaseVerificationEmailParams = v.InferOutput<
  typeof resendPurchaseVerificationEmailRpcContract.paramsSchema
>;
export type ResendPurchaseVerificationEmailResult = v.InferOutput<
  typeof resendPurchaseVerificationEmailRpcContract.resultSchema
>;
